// extracted by mini-css-extract-plugin
export default {"logo":"Logo__logo--2b2","isCenter":"Logo__isCenter--1aj","logoLink":"Logo__logoLink--2OO","container":"Logo__container--3O0","icon":"Logo__icon--1Gy"};